import React from "react";
import {useTranslation} from "react-i18next";
import CustomUserChip from "../../../../../components/CustomUserChip";
import CustomCard from "../../../../../components/CustomCard";
import {EMPTY_VALUES, getDateFormat} from "../../../../../Apis/functions";
import {
    FILE_TYPE_MODEL,
    FILE_TYPE_SIDE_MODEL,
    IDENTITY_VALIDATION_CARD_MODEL,
    IDENTITY_VALIDATION_TYPE_MODEL
} from "../Model/Model";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {CheckOutlineIcon, DeniedOutlineIcon, InfoChip} from "../../../../../components/buttons/IconButtons";
import {useSelector} from "react-redux";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import {POSITION_MODEL} from "../../../../../Helpers/PositionModel";
import {enableValidationByUserTypeId, getDocumentationTransByUserTypeId} from "../../Request/Model/Model";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */
const IdentityVerification = ({
    item,
    setShowApproveModal,
    setShowDeniedModal,
    disabled,
    identityDocuments,
    identityValidationType,
    identityValidationStatus,
    invitationId,
    userTypeId
}) => {
    const {t} = useTranslation();
    const { getInvitationById } = useSelector((state) => state.InvitationSlice);
    const userRestrictions = useSelector((state) => state.VisitorSlice.getUserRestrictionVisitor);
    const enableValidation = enableValidationByUserTypeId({ userTypeId, userRestrictions })

    const showButtonsToApprove = (!disabled && identityValidationStatus?.id === IDENTITY_VALIDATION_CARD_MODEL.PENDING_REVIEW.id
            && (!invitationId ||
                ( invitationId
                    && getInvitationById?.invitation?.statusId !== STATUS_MODEL.CANCELED
                    && getInvitationById?.invitation?.visitorStatusId !== STATUS_MODEL.CANCELED
                    && getInvitationById?.invitation?.visitorStatusId !== STATUS_MODEL.REJECTED)
            )
        );

    return (<>
            <div className='row'>
                { (!enableValidation &&
                    [IDENTITY_VALIDATION_CARD_MODEL.PENDING_TO_UPLOAD_INFORMATION.id,
                        IDENTITY_VALIDATION_CARD_MODEL.PENDING_REVIEW.id]
                        .includes(identityValidationStatus?.id)) &&
                    <div className={"col-12"}>
                        <CustomUserChip
                            className="mt-0 chip-error-code-150-100 justify-content-start d-flex my-3"
                            name={t('identity_verification_disabled')}
                            Icon={InfoChip}
                            showAvatar={true}
                            classNameIcon={"icon-color-error-code-700"}
                            variant="large"
                            iconPosition={POSITION_MODEL.LEFT}
                        />
                    </div>
                }

                <div className={"col-12"}>
                    {(identityValidationStatus?.id === IDENTITY_VALIDATION_CARD_MODEL.VALIDATED.id ||
                        identityValidationStatus?.id === IDENTITY_VALIDATION_CARD_MODEL.DENIED.id) &&
                        <CustomCard
                            classCard={identityValidationStatus.classCard}
                            children={
                                <div className={`d-flex flex-column justify-content-start gap-3`}>
                                    <div className={"gap-2"}>
                                        <p className={`ibl-font-w-600 fs-14px ${identityValidationStatus?.titleClass}`}>{t(identityValidationStatus?.titleTrans)}</p>
                                        <p className={"fs-12px ibl-font-w-600 font-color-shades-800"}>
                                            { identityValidationType?.name === IDENTITY_VALIDATION_TYPE_MODEL.MANUAL.name?
                                                item?.statusReason || EMPTY_VALUES.DEFAULT
                                                :
                                                t(identityValidationStatus?.descriptionTransVeridas)
                                            }
                                        </p>
                                    </div>

                                    { item.identityValidationApprover &&
                                        <p className={"fs-12px font-color-shades-600"}>{
                                            t(identityValidationStatus?.byTrans)} {item.identityValidationApprover} · {item.identityValidationDate !== null ? getDateFormat(item.identityValidationDate): ""}
                                        </p>
                                    }
                                </div>
                            }
                        />
                    }

                    { (enableValidation && showButtonsToApprove) &&

                        <div className={"d-flex justify-content-end"}>
                            <ButtonAction
                                Icon={CheckOutlineIcon}
                                id='btn_iv_approve'
                                className={'btn-outlined-success-600 w-40px h-40px minw-40px mr-2 p-0'}
                                iconClass={''}
                                disabled={false}
                                onClick={() => setShowApproveModal(true)}
                            />

                            <ButtonAction
                                Icon={DeniedOutlineIcon}
                                id='btn_iv_denied'
                                className={'btn-outlined-error-600 w-40px h-40px minw-40px p-0'}
                                iconClass={''}
                                disabled={false}
                                onClick={() => setShowDeniedModal(true)}
                            />
                        </div>
                    }
                </div>
            </div>
            <div className={"row mt-3 align-items-start"}>
                {Object.entries(identityDocuments).map(([key, e]) => {
                   if(key === "set" || key === "fileType" || (identityDocuments?.fileType === FILE_TYPE_MODEL.PASSPORT.id && e.index === FILE_TYPE_SIDE_MODEL.REVERSE.id )) return;

                    return  <div className={identityDocuments?.fileType === FILE_TYPE_MODEL.PASSPORT.id ? "col-sm-12 col-md-6" : e.cols}>
                        <p className={"fs-14px ibl-font-w-600"}>{t(e.titleTrans)}</p>
                        <CustomCard classCard={"card-shades-50 h-300px d-flex justify-content-center align-items-center my-2"}>
                            {e?.file ? (
                                    <img className={"image-card-grid rounded-0"} src={`data:image/png;base64,${e?.file}`} alt='add' width={"100%"} height={"100%"} />
                            ) : (
                                <e.Icon className={"image-card-grid rounded-0"} width={"100%"} height={"100%"}/>
                            )}
                        </CustomCard>
                        <p className={"fs-14px font-color-shades-500"}>{(e?.file && e?.createdAt) ? t("uploaded")+ ": " + getDateFormat(e?.createdAt, true) : t(e.noSelfie)}</p>
                    </div>
                })}
            </div>
            <div className={"row my-4"}>
                <div className={"col-12"}>
                    <div className={"d-flex align-items-center"}>
                        <CustomUserChip
                            className={`mt-0 ${identityValidationType?.chipClass}`}
                            name={t(identityValidationType?.trans)}
                            variant="large"
                        />
                        <p className={"fs-14px ibl-font-w-600"}>
                            { (identityValidationStatus?.id === IDENTITY_VALIDATION_CARD_MODEL.VALIDATED.id ||
                                identityValidationStatus?.id === IDENTITY_VALIDATION_CARD_MODEL.DENIED.id) ?
                                t(identityValidationType?.validatedDescription)
                                :
                                t(getDocumentationTransByUserTypeId({ userTypeId, identityValidationType }))
                            }
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default IdentityVerification;
